import { BaseAnalyticsService } from './baseAnalyticsService';
import * as amplitude from '@amplitude/unified';

amplitude.initAll('16dbafa6a103de419e3f12c4d2293cae', {
  analytics: { autocapture: true },
  sessionReplay: { sampleRate: 1 },
});

export class AmplitudeAnalyticsService extends BaseAnalyticsService {
  logEvent(eventName: string, eventParams?: Record<string, any>) {
    const defaultParams = {
      environment: process.env.NODE_ENV,
    };
    const finalParams = { ...defaultParams, ...eventParams };
    amplitude.logEvent(eventName, finalParams);
  }
}
